import AlertDefinitionInfoPanel from 'thm/ui/common/alertDefinition/AlertDefinitionInfoPanel'
import ChildStache from 'thm/ui/common/alertDefinition/AlertDefinitionVesselRDVInfoPanelTpl.stache'

/**
 * @class AlertDefinitionVesselRDVInfoPanel
 * Alert Definition "RDV" Form.
 */
let AlertDefinitionVesselRDVInfoPanel = AlertDefinitionInfoPanel.extend({
  id: 'alertDefinitionVesselRDVInfoPanel',
  childTpl: ChildStache,
})
export default AlertDefinitionVesselRDVInfoPanel
